export { domElementFocus }

function domElementFocus(selector) {
    document.querySelector(selector).focus()
}